import MusicSection from '../components/MusicSection'

export default function Music() {
  return (
    <main style={{ minHeight: '100vh' }}>
      <div style={{ padding: '80px 32px 0', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ paddingBottom: '24px', borderBottom: '1px solid var(--border)' }}>
          <div className="section-label">Releases & Mixes</div>
          <h1 className="section-title">Music</h1>
        </div>
      </div>
      <MusicSection limit={100} />
    </main>
  )
}
